import type { UUID } from '@cmg/common';
import { Box, List, ListItemButton, ListItemText } from '@cmg/design-system';
import React from 'react';
import { Link } from 'react-router-dom';

import routeFactory from '../../../common/util/routeFactory';

export type OfferingSetupStepId =
  | 'summary'
  | 'info'
  | 'pricing'
  | 'managers'
  | 'timing'
  | 'offering-terms'
  | 'order-book-configuration'
  | 'underwriting-terms'
  | 'marketing'
  | 'documentation'
  | 'disclaimers'
  | 'private-terms';

export type NavItem = {
  label: string;
  stepId: OfferingSetupStepId;
  getUrlPath: (args: { offeringId: UUID }) => string;
};

export type OfferingSetupNavProps = {
  activeStepId: OfferingSetupStepId | (string & {}) | undefined;
  offeringId?: UUID;
  navItems: readonly NavItem[];
};

export const OfferingSetupNav: React.FC<OfferingSetupNavProps> = ({
  activeStepId,
  offeringId,
  navItems,
}) => {
  return (
    <Box
      bgcolor={theme => theme.palette.background.lightGrey}
      width={theme => theme.spacing(31.5)}
      flexShrink={0}
    >
      <List component="nav">
        {navItems.map(({ label, stepId, getUrlPath }) => {
          const isSelected = stepId === activeStepId;
          const disabled = !isSelected && !offeringId;
          const to = offeringId
            ? getUrlPath({ offeringId })
            : routeFactory.offeringCreate.getUrlPath();

          return (
            <ListItemButton
              key={stepId}
              selected={isSelected}
              disabled={disabled}
              component={Link}
              to={to}
            >
              <ListItemText primaryTypographyProps={{ pl: 2 }}>{label}</ListItemText>
            </ListItemButton>
          );
        })}
      </List>
    </Box>
  );
};
